import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Typography,
  Stack,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BudgetTableContainer } from 'pages/calculator/MediaPlanning/common/BudgetTable/styles';
import { DdxState } from '../../../../../store/planStore';
import convertDecimalToPercentValue from '../../Plan/Countries/utils/convertDecimalToPercentValue';
import DDXInfoRow from '../DDXInfoRow/DDXInfoRow';
import linksConfig from '../../../../../config/linking';
import HelperTooltip from '../../../../../shared/HelperTooltip/HelperTooltip';

interface DDXAcquisitionTableProps {
  currency?: string;
  ddx?: DdxState;
}

function DDXAcquisitionTable({ ddx, currency }: DDXAcquisitionTableProps) {
  const { t } = useTranslation();

  const getDDX = () => {
    switch (ddx?.type) {
      case 'omitted':
        return 'No 1P Data Acquisition';
      case 'percentage':
        return `Division Rate: ${convertDecimalToPercentValue(ddx?.value)}%`;
      case 'fixed':
        return `Division Rate: ${ddx?.value} ${currency}`;
      default:
        return null;
    }
  };

  return (
    <Grid container sx={{ px: '15px' }}>
      <Grid item xs={12}>
        <Stack flexDirection="row">
          <Typography
            textTransform="uppercase"
            fontWeight={700}
            sx={{ pb: '12px' }}
          >
            {t('mediaPlanning.ddx1pAcquisition')}
          </Typography>
          <HelperTooltip tooltipData={linksConfig.ddx1pAcquistion} />
        </Stack>
        <BudgetTableContainer>
          <Table sx={{ tableLayout: 'fixed' }}>
            <TableHead>
              <TableRow sx={{ width: '100%' }}>
                <TableCell sx={{ width: '34px' }} />
                <TableCell align="left" sx={{ width: '100%' }}>
                  <Typography variant="caption" fontWeight={600}>
                    {getDDX()}
                  </Typography>
                </TableCell>
                <TableCell sx={{ width: '200px' }} />
              </TableRow>
            </TableHead>
            <TableBody>
              <DDXInfoRow ddx={ddx} currency={currency} />
            </TableBody>
          </Table>
        </BudgetTableContainer>
      </Grid>
    </Grid>
  );
}

export default DDXAcquisitionTable;
